<div class="table-container">
    <aside class="locked">
        <table>
            <thead>
                <tr>
                    <th>{{ variation.axesLabels.categories }}</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let dataset of variation.stacks[0].datasets" class="{{lineClass}}">
                    <td>{{ dataset.label }}</td>
                </tr>
            </tbody>
        </table>
    </aside>

    <section class="years-data">
        <table>
            <thead>
                <tr>
                    <th *ngFor="let label of variation.labels">{{ label }}</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let dataset of variation.stacks[0].datasets" class="{{lineClass}}">
                    <td *ngFor="let data of dataset.data">
                        <span class="amount" *ngIf="variation.dataType === dataType.amount">
                            {{ data | formatAmount }}
                        </span>
                        <span class="percent" *ngIf="variation.dataType === dataType.percent">
                            {{ data | formatPercent }}
                        </span>
                    </td>
                </tr>
            </tbody>
        </table>
    </section>
</div>
